/**
 * The one list the command dashboard needs on top of the board and the convoys
 * it is already handed: the audit ledger. It is read through its own store —
 * nothing here talks to Dexie directly — and re-read off the global reactive
 * store, so an override taken on the tasks board shows up in "עקיפות והתראות
 * היום" without the screen being revisited.
 */
import { useCallback, useEffect, useState } from 'react';
import { listAuditLogs } from '../../db/audit-store';
import { useStoreEvents } from '../../hooks/use-store-events';
import type { AuditLogEntry } from '../../types/audit';

export interface DashboardData {
  auditLogs: AuditLogEntry[];
  loading: boolean;
  reload: () => Promise<void>;
}

export function useDashboard(): DashboardData {
  const [auditLogs, setAuditLogs] = useState<AuditLogEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setAuditLogs(await listAuditLogs());
  }, []);

  useEffect(() => {
    void (async () => {
      await reload();
      setLoading(false);
    })();
  }, [reload]);

  useStoreEvents(reload);

  return { auditLogs, loading, reload };
}
